export default {
  init() {
    // JavaScript to be fired on the home page
    var callback = function (data) {
      $.each(data, function (key, match) {
         if (match) {
          var id = key,
          status = match.time.status,
          oriminute = null == match.time.minute ? 1 : match.time.minute,
          minute = oriminute;
          if (0 < $('#match-child-' + id).length) {
            $('#match-child-' + id + ' .grid-match__live-now').css('display', 'inline-block');
            $('#match-child-' + id + ' .grid-match__live-time').css({
              background: 'rgb(0, 155, 50)',
              border: '1px solid rgb(0, 155, 50)',
            });
            if (null != match.time.injury_time && 0 < match.time.injury_time && (minute = minute + '+' + match.time.injury_time), 'NS' == status || 'FT' == status || 'FT_PEN' == status) 'FT' != status && 'FT_PEN' != status || $('#match-child-' + id + ' .grid-match__live-time').html('HẾT GIỜ') , $('#match-child-' + id + ' .grid-match__live-time').css({background: '#d03c3c',border: '1px solid #d03c3c'});
            else if ($('#match-child-' + id + ' .grid-match__live-time').addClass('t_timeRun'), 'PEN_LIVE' == status || 'LIVE' == status || 'AET' == status || 'BREAK' == status || 'HT' == status || 'ET' == status) {
                var text = '';
                $('#match-child-' + id).attr('data-now','on');
                'HT' == status && (text = 'Nghỉ giữa hiệp'), 'LIVE' == status && (45 <= oriminute && (text = 'Hiệp 2: '), text = text + minute + '\''), 'PEN_LIVE' == status && (text = 'Penalty'), 'AET' == status && (text = 'Đá hiệp phụ'), 'BREAK' == status && (text = 'Chuẩn bị đá hiệp phụ'), 'ET' == status && (text = 'HIỆP PHỤ'), $('#match-child-' + id + ' .grid-match__live-time').html(text)
            } else {
                text = '';
                'CANCL' == status && (text = 'HỦY TRẬN'), 'POSTP' != status && 'ABAN' != status && 'SUSP' != status || (text = 'HOÃN TRẬN'), 'INT' == status && (text = 'Trận đấu gián đoạn'), 'AWARDED' == status && (text = 'KO ĐÁ'), 'DELAYED' == status && (text = 'LÙI GIỜ ĐÁ'), 'TBA' == status && (text = 'CHƯA XÁC ĐỊNH'), $('#match-child-' + id + ' .grid-match__live-time').css({background: '#d03c3c',border: '1px solid #d03c3c'}), $('#match-child-' + id + ' .grid-match__live-time').html(text)
            }
            if ('PEN_LIVE' == status || 'LIVE' == status || 'AET' == status || 'BREAK' == status || 'HT' == status || 'ET' == status || 'INT' == status || 'FT' == status || 'FT_PEN' == status) {
              var scores = match.scores;
              $('#match-child-' + id + ' .grid-match__vs').html(scores.localteam_score + ' - ' + scores.visitorteam_score)
            } else $('#match-child-' + id + ' .grid-match__vs').html('vs')
          }
        }
      });
    }
    var fetchData = function () {
      var time = jQuery.now();
      var url = 'https://data.p2pcdn.xyz/livedata/results.json?ver='+time;
      $.getJSON(url, callback);
    };
    fetchData();
    setInterval(fetchData, 25000);
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-live.js